export const SECOND_TO_MILLISECONDS = 1000;
export const EXTRA_GAS_FEE_AMOUNT = '1000000000000000'; // 0.001 EGLD in wei
export const EGLD_DECIMALS = 18;
export const MAX_PERCENTAGE = 100_00; // 100%
export const NFT_QUANTITY = 1;
export const MAX_GAS_LIMIT = 600000000;  // 600M
export const HOUR_IN_SECONDS = 3600;
export const DAY_IN_SECONDS = 86400;
export const YEAR_IN_SECONDS = DAY_IN_SECONDS * 365;
export const ASH_LP_DECIMALS = 18;
